// @flow
import compact from 'lodash/compact';
import { getSearchUrlWithParams } from '../../utils/urls';
import union from 'lodash/union';

/* SELECTORS */
const toFacetLabel = (facet: any, value: any) => {
    const selectionType = facet.selection;
    if (selectionType === 'single') {
        return value.name;
    }
    if (selectionType === 'single2') {
        return value.name;
    }
    if (selectionType === 'distance') {
        return `${facet.name}: ${facet.selected_postal_code}`;
    }
    if (selectionType === 'range') {
        return `${facet.name}: ${facet.selected_start} - ${facet.selected_end}`; // add in currency
    }
    if (selectionType === 'multiple') {
        return value.name;
    }
    if (selectionType === 'keyword') {
        return facet.selected_value;
    }
    if (selectionType === 'date') {
        return facet.name;
    }
};

export const toFacetString = (facets: any) => {
    const selections = [];
    facets.forEach(facet => {
        if (facet.qs === 'keyword') {
            selections.unshift(toFacetLabel(facet));
        } else if (facet.qs === 'status') {
        } else if (facet.values) {
            facet.values.forEach(value => {
                selections.push(toFacetLabel(facet, value));
            });
        } else {
            selections.push(toFacetLabel(facet));
        }
    });
    return compact(selections).join(', ');
};

export const toFacetStringWithCount = (search: any) => {
    let fullString = toFacetString(search.facets);
    if (fullString.length > 35) {
        fullString = `${fullString.substr(0, 35)}...`;
    }
    fullString = `${fullString} (${search.itemCount || 0})`;
    return fullString;
};

const toFacetUrlParam = (facet, oldValue) => {
    const selectionType = facet.qs;
    if (facet.selection === 'single' || facet.selection === 'multiple') {
        const oldValues = oldValue ? oldValue.split(',') : [];
        const newValues = facet.values.map(x => `${x.value}`);
        return union(oldValues, newValues).join(',');
    }
    if (selectionType === 'keyword') {
        return facet.selected_value; // overwrite old value
    }
    if (facet.selection === 'range') {
        const oldValues = oldValue ? oldValue.split(',') : [];

        const currency = facet.currencies.length ? facet.currencies[0].code : 'USD';
        const min = facet.selected_start;
        const max = facet.selected_end;
        const minValue = min !== '' && min !== undefined ? min : -1;
        const maxValue = max !== '' && max !== undefined ? max : -1;
        const newValue = `${currency}:${minValue}:${maxValue}`;

        return union(oldValues, [newValue]).join(',');
    }
    if (facet.selection === 'distance') {
        const oldValues = oldValue ? oldValue.split(',') : [];

        const country = facet.selected_country;
        const zipCode = facet.selected_postal_code;
        const range = facet.selected_radius;
        const measurement = facet.selected_radius_unit;
        const newValue = `${country}:${zipCode}:${range}:${measurement}`;

        return union(oldValues, [newValue]).join(',');
    }
};

export const toFacetUrlParams = (facets: any) => {
    const url = {
        // published_date: null,
        // sort: '-publish_date',
    };
    facets.forEach(facet => {
        url[facet.qs] = toFacetUrlParam(facet, url[facet.qs]);
    });
    return url;
};

export const toSearchUrl = (facets: any) => {
    const urlParams = toFacetUrlParams(facets);
    return getSearchUrlWithParams(urlParams);
};
